import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import Strings from "@my-dld/assets/strings";
import { ExternalValuationProps, TrackIndex } from "./index";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import { exToMessage } from "@eres/ssoapi/api";
import { ExternalValuationApi } from "../../valuationapi";
import { ValuationCompany } from "../../valuationapi/entities";
import PickerInput from "@eres/forms-web/PickerInput";
import { LocaleUtil } from "@eres/core";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import FormRow from "@eres/forms-web/FormRow";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { navigate } from "@my-dld/utils/StoreUtils";

interface LookupState {
	ValuationCompanies?: ValuationCompany[];
}

interface Props extends ExternalValuationProps {

}

interface State extends LookupState {
	property: AssetCard;
	companyId?: string;
}

class SelectValuationCompany extends Component<Props, State> {
	apiHandler: any;
	apiExHandler: any;
	propertyId: any;

	constructor( props: ExternalValuationProps ) {
		super( props );
		this.state = {
			property: props.property,
		};
	}

	componentDidMount() {
		this.getValuationCompanies();
	}

	sortedCompanies( companies: ValuationCompany[] ): ValuationCompany[] {
		const sortedCompanies = companies.sort( ( a: ValuationCompany, b: ValuationCompany ) => {
			const aName = LocaleUtil.getLocalValue( a.name );
			const bName = LocaleUtil.getLocalValue( b.name );
			return aName.trim().toLowerCase().localeCompare( bName.trim().toLowerCase() );
		} );
		return sortedCompanies;
	}

	render() {
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
		};
		const { ValuationCompanies } = this.state;
		return <>
			<div className="card">
				<div className="card-header">{ Strings.external_valuation }</div>
				<div className="card-body">
					<div className="mandatory-field-info">
						<small>{ Strings.mandatory_fields_note }</small>
					</div>

					{ this.props.property.propertyTypeId === TabuPropertyType.LAND && <div className="form-group">
						<label>{ Strings.empty_land_confirm }</label>
						<div>
							<div className="btn-group btn-toggle btn-custom-toggle">
								<button
									onClick={ () => {
										this.props.setEmptyLand( true );
									} } type="button" className={ this.props.emptyLand() ? "btn active" : "btn" }>{ Strings.yes }</button>
								<button
									onClick={ () => {
										this.props.setEmptyLand( false );
									} } type="button" className={ !this.props.emptyLand() ? "btn active" : "btn" }>{ Strings.no }</button>
							</div>
						</div>
					</div> }

					<FormRow { ...filedProps }>
						<PickerInput
							required={ true }
							isLoading={ ValuationCompanies === undefined }
							id={ "companyId" }
							toIdentifier={ idExtractor }
							label={ Strings.select_valuation_company }
							formatter={ ( company: ValuationCompany ) => LocaleUtil.getLocalValue( company.name ) }
							onValueChange={ ( company: any ) => this.props.setValuationCompany( company ) }
							items={ ValuationCompanies }/>
					</FormRow>
				</div>
			</div>
			<button
				onClick={ this.onCancel } className="btn btn-grey btn_style1 mt-3 mb-3 me-2" type="submit"
				id="viewValuationDetails"> { Strings.cancel }
			</button>

			{ this.state.companyId &&
				<button
					onClick={ this.onProceed } className="btn btn_1 btn_style1 mt-3 mb-3" type="submit"
					id="viewValuationDetails"> { Strings.next }
				</button> }
		</>;
	}

	private getValuationCompanies() {
		ExternalValuationApi.getAuthorities().then( ( response: any ) => {
			if ( response.response.validationErrorsList && response.response.validationErrorsList.length > 0 ) {
				showErrorMessage( ExternalValuationApi.getValidationError( response.response.validationErrorsList ) );
			} else {
				let companies: ValuationCompany[] = [];
				response.response.authority.map( ( company: ValuationCompany ) => {
					companies.push( company );
				} );
				this.setState( { ValuationCompanies: this.sortedCompanies( companies ) } );
			}
		} )
		.catch( e => {
			exToMessage( e ).then( message => {
				let key = "newPwd";
				if ( message.src && message.src === "old" ) {
					key = "current";
				}
			} );
		} );
	}

	private onProceed = () => {
		this.props.onNext( TrackIndex.VALUATION_FORM );
	};

	private onCancel = () => {
		navigate( "/mydld/dashboard" );
	};
}

const idExtractor = ( e: any ) => e ? "" + e.id : undefined;
export default SelectValuationCompany;
